module.exports = __webpack_public_path__ + "media/images/logos/logo-65a60d4d96522dbbae60eb679522dcf3.png";